<template>
  <div id="error-msg">
    <h2>{{ msg }}</h2>
  </div>
</template>

<script>
export default {
  props: ['msg'],
  data() {
      return {
        name: 'Error message'
      }
  }
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

h2 {
    color: $red;
}
</style>
